import { Reveal } from "@/components/Reveal";
import { CTAPrimary } from "@/components/primitives";

export default function FinalCTA() {
  return (
    <section className="py-28 md:py-40 bg-navy text-warm grain" data-testid="final-cta-section">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <div className="max-w-4xl">
          <Reveal>
            <span className="overline inline-flex items-center gap-3 text-warm/60">
              <span className="w-8 h-px bg-gold" />The Invitation
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-8 font-heading font-light tracking-tight text-5xl md:text-7xl lg:text-8xl leading-[0.98]">
              Where Should Your<br />Company Be Visible?
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-10 max-w-2xl text-lg md:text-xl leading-relaxed text-warm/70 font-body">
              Your next visibility opportunity may already exist. The question is whether it is the
              right one.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-12">
              <CTAPrimary to="/contact" testId="final-cta-button">Map Your Visibility</CTAPrimary>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
